<template>
    <!-- Slider -->
    <div class="grid grid-cols-1">
        <Slider />
    </div>

    <section class="px-10 2xl:px-96 bg-white">
        <h2 class="py-10 text-2xl uppercase text-center font-bold text-green-600">Kabar Kita</h2>
        <!-- Main Grid -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 pb-16">
            <!-- Card -->
            <div v-for="berita in beritas.slice(0,3)" :key="berita.id" class="card bg-white rounded-lg text-left pb-5 text-green-600 shadow-lg">
                <router-link :to="{name: 'berita.show', params:{slug:berita.slug}}">
                    <div class="w-full">
                        <img :src="berita.image" alt="" class="object-cover object-center h-52 w-full rounded-t-lg">
                    </div>
                    <h3 class="text-lg font-bold pt-1 px-5">{{berita.judul}}</h3>
                    <p class="pb-2 px-5 text-sm">{{berita.penulis}}</p>
                    <p class="text-left px-5" v-html="berita.isi.length > 25 ? berita.isi.slice(0, 25) + '...' : berita.isi"></p>
                </router-link>
            </div>
        </div>
    </section>

    <WhatsappButton/>
</template>

<script>

    //hook vue
    import { computed, onMounted } from 'vue'

    //vuex
    import { useStore } from 'vuex'

    //component slider
    import Slider from '@/components/Slider.vue'

    // component WhatsappButton
    import WhatsappButton from '@/components/WhatsappButton.vue'

    export default {

        components: {
            Slider,         // <-- register component slider
            WhatsappButton,
        },

        setup() {

            //store vuex
            const store = useStore()

            //onMounted akan menjalankan action "getCampaign" di module "campaign"
            onMounted(() => {
                store.dispatch('berita/getBerita')
            })

            // Storing Berita
            const beritas = computed(() => {
                return store.state.berita.beritas
            })

            return {
                beritas,        // <-- return beritas
            }
        }
    }
</script>
